import { render, staticRenderFns } from "./UiKit.vue?vue&type=template&id=048c1214&scoped=true&"
import script from "./UiKit.vue?vue&type=script&lang=ts&"
export * from "./UiKit.vue?vue&type=script&lang=ts&"
import style0 from "./UiKit.vue?vue&type=style&index=0&id=048c1214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048c1214",
  null
  
)

export default component.exports